import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';

function MapMultiSelect(props: {
  categoryNames: string[];
  setCategoryNames: React.Dispatch<React.SetStateAction<string[]>>;
  categoryNameAll: string[] | [];
  openSelect: boolean;
  setOpenSelect: any;
}): JSX.Element {
  const { categoryNames, setCategoryNames, categoryNameAll, openSelect, setOpenSelect} = props;
  const { t } = useTranslation();

  const getStyles = (name: string) => ({

    fontWeight: categoryNames.indexOf(name) === -1 ? 'normal' : 'bold',
  });

  return (
    <Autocomplete
      multiple
      id="categories-autocomplete"
      noOptionsText={t('component.mapMultiSelect.noOptions')}
      options={categoryNameAll}
      value={categoryNames}
      onChange={(_, newValue) => setCategoryNames(newValue)}
      open={openSelect}
      onOpen={() => setOpenSelect(true)}
      isOptionEqualToValue={(option: string, value: string) => option === value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={categoryNames.length > 0 ? '' : t('component.mapMultiSelect.placeholder')}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
              </>
            ),
          }}
        />
      )}
      sx={{ background: '#f5f5f5' }}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props} style={getStyles(option)}>
          <ListItemText primary={option} />
          {selected ? (
            <ListItemIcon>
              <ClearIcon />
            </ListItemIcon>
          ) : null}
        </MenuItem>
      )}
      style={{ width: '100vw' }}
      autoComplete={false}
    />
  );
}

export default MapMultiSelect;
